import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HandoverHistory, HandoversHistory } from 'src/app/interfaces/handover';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';

@Component({
  selector: 'app-handover-history',
  templateUrl: './handover-history.component.html',
  styleUrls: ['./handover-history.component.scss'],
  standalone: false,
})
export class HandoverHistoryComponent implements OnInit {
  @Input() wellId: string | undefined;
  @Input() wellCommonName: string | undefined;
  @Input() handoversCountToShow: number | undefined;
  @Input() showHeader: boolean | undefined;

  totalHandoversHistory = 0;
  handovershistory: HandoverHistory[] = [];
  indexHandoverButton = -1;

  constructor(
    private handoverService: HandoverService,
    private dialogService: DialogService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getHandoversHistory();
  }

  getHandoversHistory(): void {
    this.handoverService
      .getHandoversHistory(this.wellId!, this.handoversCountToShow)
      .subscribe((hh: HandoversHistory) => {
        this.handovershistory = hh.handoversListDetails;
        this.totalHandoversHistory = hh.totalAmountOfHandovers;
      });
  }

  viewAllHandovers(): void {
    this.dialogService.openHandoverHistoryDialog(
      this.wellId!,
      this.wellCommonName!,
      this.totalHandoversHistory
    );
  }

  viewHandover(handoverId: number): void {
    this.router.navigateByUrl(`handover/${handoverId}`, {
      state: { backTo: 'search-well' },
    });
  }
}
